"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importDefault(require("react"));
var CurrentLevel_1 = __importDefault(require("./CurrentLevel"));
var Levels_1 = __importDefault(require("./Levels"));
var RewardTable_1 = __importDefault(require("./RewardTable"));
var Terms_1 = __importDefault(require("./Terms"));
var useLevelsPrizes_1 = require("./useLevelsPrizes");
var ui_components_1 = require("@l2p/ui-components");
var LoyaltyCardAlternative = function (_a) {
    var htmlContent = _a.htmlContent;
    var _b = (0, swr_hooks_1.useLevels)(), data = _b.data, isLoading = _b.isLoading;
    var dataWithPrizes = (0, useLevelsPrizes_1.useLevelsPrizes)(data);
    var _c = (0, swr_hooks_1.usePlayerStatus)(), level = _c.currentLevelInfo, progressPercents = _c.progressPercents, userPoints = _c.userPoints, nextLevelMin = _c.nextLevelMin;
    if (isLoading)
        return react_1.default.createElement(ui_components_1.PageLoading, { imageUrl: "/img/bc_preloader.gif" });
    return (react_1.default.createElement("div", null,
        (level === null || level === void 0 ? void 0 : level.level) && (react_1.default.createElement(CurrentLevel_1.default, { level: level, currentLevelData: dataWithPrizes[level.level - 1], progressPercents: progressPercents, userPoints: userPoints, nextLevelMin: nextLevelMin })),
        react_1.default.createElement(Levels_1.default, { data: dataWithPrizes, level: (level === null || level === void 0 ? void 0 : level.level) || 1 }),
        react_1.default.createElement(RewardTable_1.default, null),
        react_1.default.createElement(Terms_1.default, { htmlContent: htmlContent })));
};
exports.default = LoyaltyCardAlternative;
